// extracted by mini-css-extract-plugin
export var alignLeft = "y_rd d_fp d_bG d_dv";
export var alignCenter = "y_bP d_fq d_bD d_dw";
export var alignRight = "y_rf d_fr d_bH d_dx";
export var container = "y_mw d_dW d_Z";
export var containerFull = "y_tf d_dT d_Z";
export var carouselWrapper = "y_k6 d_w d_bz d_bD";
export var design1Elements = "y_tg";
export var step1 = "y_th";
export var step1ContentWrapper = "y_tj";
export var step2 = "y_tk d_b5";
export var top1 = "y_tl d_w d_bC d_bP d_cs";
export var top2 = "y_tm y_tl d_w d_bC d_bP d_cs";
export var design2 = "y_tn";
export var line = "y_fk d_w";